import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Check } from 'lucide-react';
import { API, errText } from '../../api';
import { MARKETING } from '../../mock';

export default function MarketingPanel({ requestCode, items, onItems, preselect }) {
  const [kinds, setKinds] = useState([]);
  useEffect(() => { if (preselect) setKinds(preselect); }, [preselect]);
  const [note, setNote] = useState('');
  const toggle = (t) => setKinds((k) => (k.includes(t) ? k.filter((x) => x !== t) : [...k, t]));

  const sendQuote = async () => {
    try {
      const item = await API.createMarketing({ request_id: requestCode, kinds, note });
      onItems((prev) => [item, ...prev]);
      setKinds([]); setNote('');
      toast.success('Quote request sent.', { description: 'Perry will reply with a price here and by email.' });
    } catch (e) { toast.error(errText(e, 'Could not send your request.')); }
  };
  const pay = async (m) => {
    try {
      const { checkout_url } = await API.checkout({ kind: 'marketing', code: m.code });
      window.location.assign(checkout_url);
    } catch (e) { toast.error(errText(e, 'Could not start checkout.')); }
  };

  return (
    <div className="panel rounded-3xl p-6" id="marketing-panel" data-testid="marketing-panel">
      <h3 className="font-display text-2xl text-cream mb-1">Put your song <span className="italic text-gold-grad">to work.</span></h3>
      <p className="text-sm text-cream/55 mb-5">Pick what you want help with. Perry sends you a quote right here.</p>
      <div className="space-y-2.5">
        {MARKETING.map((m) => (
          <button key={m.id} onClick={() => toggle(m.title)} data-testid={`marketing-kind-${m.id}`} className={`w-full text-left rounded-xl border p-3.5 transition-colors flex gap-3 ${kinds.includes(m.title) ? 'border-gold/50 bg-gold/[0.04]' : 'hairline hover:border-gold/30'}`}>
            <span className={`grid place-items-center w-5 h-5 rounded border shrink-0 mt-0.5 ${kinds.includes(m.title) ? 'bg-gold border-gold' : 'border-cream/30'}`}>{kinds.includes(m.title) && <Check size={12} className="text-ink" />}</span>
            <span><span className="block text-cream text-sm font-medium">{m.title}</span><span className="block text-cream/50 text-xs mt-0.5">{m.body}</span></span>
          </button>
        ))}
      </div>
      <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2} placeholder="Anything Perry should know? Dates, goals, budget." className="mt-4 w-full rounded-xl border hairline bg-panel2/50 px-4 py-3 text-sm text-cream placeholder:text-cream/35 outline-none focus:border-gold/50 transition-colors resize-none" />
      <button onClick={sendQuote} disabled={!kinds.length} data-testid="marketing-request-quote-btn" className={`mt-4 w-full rounded-full py-3 text-sm ${kinds.length ? 'btn-gold' : 'btn-ghost opacity-60'}`}>Request a quote</button>

      {items.map((m) => (
        <div key={m.code} className="mt-4 rounded-2xl border border-gold/25 bg-gold/[0.04] p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="font-display text-lg text-cream">{m.code}</span>
            <span className={`text-[10px] font-mono tracking-widest uppercase rounded-full px-2.5 py-1 ${m.status === 'paid' ? 'border border-emerald-500/40 text-emerald-400' : m.status === 'quoted' ? 'border border-gold/50 text-gold' : 'border border-gold/40 text-gold/80'}`}>{m.status === 'new' ? 'Quote coming' : m.status === 'quoted' ? `Quote $${m.quote}` : 'Paid'}</span>
          </div>
          <p className="text-xs text-cream/60 mb-2">{m.kinds.join(' \u00b7 ')}</p>
          {m.status === 'new' && <p className="text-xs text-cream/45">Perry is putting your quote together.</p>}
          {m.status === 'quoted' && <button data-testid={`pay-marketing-${m.code}`} onClick={() => pay(m)} className="mt-1 btn-gold rounded-full px-4 py-2 text-xs">Pay ${m.quote}</button>}
        </div>
      ))}
    </div>
  );
}
